import React from "react";
import MasterCheckList, {
  MasterCheckItem,
} from "../../../../components/masterData/MasterCheckList";
import MasterSearchField from "../../../../components/masterData/MasterSearchField";

export function DeaneryParishAssignments({
  items,
  filter,
  onFilter,
  onToggle,
}: {
  items: MasterCheckItem[];
  filter: string;
  onFilter: (value: string) => void;
  onToggle: (id: string | number) => void;
}) {
  return (
    <>
      <MasterSearchField
        value={filter}
        onChange={(event) => onFilter(event.target.value)}
        placeholder="Filter parishes..."
      />
      <MasterCheckList
        items={items}
        emptyLabel="No parishes in this diocese / category."
        onToggle={onToggle}
      />
    </>
  );
}
